import type { AccountReferenceDataField } from '@/api/accountData'

export const accountReferenceFieldLabels: Record<AccountReferenceDataField, string> = {
  phone_number: '電話號碼',
  fax_number: '傳真號碼',
  bank_name: '銀行名稱',
  bank_account_name: '銀行戶名',
  bank_swift_code: '銀行代碼',
  intermediary_bank_swift_code: '中間行代碼',
  email: '電子郵件',
  mailing_address: '郵寄地址',
  residence_address: '居住地址',
  company_address: '公司地址',
  registered_address: '註冊地址',
  bank_account_number: '銀行帳號',
  intermediary_bank_name: '中間行名稱',
  nationality: '國籍',
  business_location: '公司註冊地',
}

export const accountReferenceFields: AccountReferenceDataField[] = [
  'nationality',
  'email',
  'phone_number',
  'fax_number',
  'mailing_address',
  'residence_address',
  'company_address',
  'registered_address',
  'business_location',
  'bank_account_name',
  'bank_account_number',
  'bank_name',
  'bank_swift_code',
  'intermediary_bank_name',
  'intermediary_bank_swift_code',
]

/**
 * 聯名戶中屬於整個帳戶的銀行資料，不依 BNP `ord` 分派給個別持有人。
 * 匯入預覽與客戶資料歸屬判斷都應將這些欄位放在主帳戶區。
 */
export const accountLevelReferenceFields: AccountReferenceDataField[] = [
  'bank_name',
  'bank_account_name',
  'bank_swift_code',
  'bank_account_number',
  'intermediary_bank_name',
  'intermediary_bank_swift_code',
]

export function isAccountLevelReferenceField(field: string): field is AccountReferenceDataField {
  return accountLevelReferenceFields.includes(field as AccountReferenceDataField)
}

export type AccountReferenceDataOwner = 'subscriber' | 'unknown' | `shareholder:${number}`

/** 依帳戶類型、欄位與 ord 判斷保銀留存資料的畫面歸屬。 */
export function accountReferenceDataOwner(
  field: string,
  ord: number | null | undefined,
  joint: boolean,
  shareholderCount: number,
): AccountReferenceDataOwner {
  if (!joint || isAccountLevelReferenceField(field)) return 'subscriber'
  if (ord === 0) return 'subscriber'
  if (ord !== null && ord !== undefined && ord > 0 && ord <= shareholderCount) return `shareholder:${ord}`
  return 'unknown'
}

export function normalizeImportField(field: string): AccountReferenceDataField | null {
  return accountReferenceFields.includes(field as AccountReferenceDataField) ? field as AccountReferenceDataField : null
}
